import React from 'react';
import { useHistory } from 'react-router-dom';
import ContactSupportLink from '../components/ContactSupportLink';
import { ROUTES } from '../routes/routes';

export default function NotFound() {
    const history = useHistory();
    const handleBackToDashboard = () => {
        history.push(ROUTES.DASHBOARD);
    };

    return (
        <div className="h-screen w-full bg-gray-100 flex items-center">
            <div className="container flex flex-col md:flex-row items-center justify-center px-5 text-gray-700">
                <div className="max-w-md">
                    <p className="text-2xl md:text-3xl font-light leading-normal">Sorry we couldn't find this page. </p>
                    <p className="mb-8">
                        Why not head back to the dashboard. If you still end up here, please <ContactSupportLink />
                    </p>

                    <button
                        onClick={handleBackToDashboard}
                        className="px-4 inline py-2 text-sm font-medium leading-5 shadow text-white transition-colors duration-150 border border-transparent rounded-lg focus:outline-none focus:shadow-outline-blue bg-blue-600 active:bg-blue-600 hover:bg-blue-700"
                    >
                        Back to Dashboard
                    </button>
                </div>
            </div>
        </div>
    );
}
